<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/171smVn/tc-custom/9781504003629.jpg?1734405274102" alt="This image is the cover for the book Lost Codex, OPSIG Team Black"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lost Codex, OPSIG Team Black
      </h1>
      <p class="bookDescription body article font2">
        <b>In this “brilliant” thriller from the <i>USA Today</i>–bestselling author, ancient biblical documents are at the center of a devastating terrorist threat (Jeffery Deaver).</b><br/><br/> In 930 CE, a revered group of scholars pens the first sanctioned Bible, planting the seed from which other major religions will grow. But in 1953, half the manuscript goes missing while being transported from Syria. Around the same time, in the foothills of the Dead Sea, an ancient scroll is discovered—and promptly stolen.<br/><br/> Six decades later, both parchments stand at the heart of a geopolitical battle between foreign governments and radical extremists, threatening the lives of millions. With the American homeland under siege, the president turns to a team of uniquely trained covert operatives including FBI profiler Karen Vail, Special Forces veteran Hector DeSantos, and FBI terrorism expert Aaron Uziel. Their mission: Find the stolen documents and capture—or kill—those responsible for unleashing a coordinated and unprecedented terrorist attack on US soil.<br/><br/> Set in DC, New York, Paris, England, and Israel, <i>The Lost Codex</i> has been hailed by Douglas Preston as “a masterwork of international suspense” and “an outstanding novel."
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alan Jacobson
      </h2>
      
      <p class="authorDescription body article">Alan Jacobson is the national bestselling author of the critically acclaimed FBI profiler Karen Vail and OPSIG Team Black series. Jacobson&rsquo;s years of extensive research and training while embedded with federal and local law enforcement agencies have influenced him both personally and professionally, and have helped shape the stories he tells and the diverse characters that populate his novels.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a0fcd444